export const VOBS_COLORS = {
  // Tokens de tema (azul = info, verde-azulado = sucesso, âmbar = aviso): seguem claro/escuro.
  blue: {
    bg: 'var(--ee-info-bg)',
    text: 'var(--ee-info-fg)',
    hover: 'var(--ee-info-border)',
    accent: 'var(--ee-info-solid)',
  },
  teal: {
    bg: 'var(--ee-success-bg)',
    text: 'var(--ee-success-fg)',
    hover: 'var(--ee-success-border)',
    accent: 'var(--ee-success-solid)',
  },
  amber: {
    bg: 'var(--ee-warning-bg)',
    text: 'var(--ee-warning-fg)',
    hover: 'var(--ee-warning-border)',
    accent: 'var(--ee-warning-solid)',
  },
} as const;

export type VobsColorTheme = keyof typeof VOBS_COLORS;

export const VOBS_PRODUCTS = {
  dadvaz: {
    title: 'DADVAZ',
    subtitle: 'Modelo DESSEM',
    color: 'blue' as VobsColorTheme,
    icon: 'D',
    description:
      'Arquivo dadvaz.dat alimentado diretamente com vazões observadas em base diária. Sem projeções — ideal para validação do DESSEM com dados dados da operação real. Disponível desde out/2024, até D-1 ou D-2. Atualizado diariamente acompanhando a consistência de dados hidrológicos.',
    granularity: 'diária',
    format: '.dat',
  },
  prevs_sem: {
    title: 'PREVS semanal',
    subtitle: 'Modelo DECOMP',
    color: 'teal' as VobsColorTheme,
    icon: 'S',
    description:
      'Arquivo PREVS.REVF produzido estritamente com as médias semanais das vazões observadas. Ideal para estudos de validação do modelo DECOMP com dados da operação real. Representação semanal preservada para acompanhar a discretização habitual do modelo DECOMP. Disponível assim que os relatórios de acompanhamento hidrológico contemplarem todos os dias daquele mês civil. Atualizado diariamente acompanhando a consistência de dados hidrológicos.',
    granularity: 'semanal',
    format: '.REVF',
  },
  prevs_men: {
    title: 'PREVS mensal',
    subtitle: 'Modelo DECOMP',
    color: 'amber' as VobsColorTheme,
    icon: 'M',
    description:
      'Arquivo PREVS.REVF produzido estritamente com a média mensal das vazões observadas. Alternativa ao PREVS semanal, deve ser utilizado em estudos de validação do modelo DECOMP com dados da operação real nos quais a discretização de estágios seja também em base mensal. Disponível assim que os relatórios de acompanhamento hidrológico contemplarem todos os dias daquele mês civil. Atualizado diariamente acompanhando a consistência de dados hidrológicos.',
    granularity: 'mensal',
    format: '.REVF',
  },
} as const;

export const DADVAZ_MIN_DATE = new Date(2018, 0, 2); // 2018-01-02

export const MONTHS_PT = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
] as const;
